export default __webpack_public_path__ + "static/media/facebook-smile.41367b57.svg";